import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_GREETING: IntlKeyValuePair = {
    key: "greeting",
    defaultValue: (name: string) => `${name}, help us tailor your experience ✨`,
    intlValue: "{{name}}, help us tailor your experience ✨",
    namespace: IntlNamespaces.UNIVERSITY_CHAT,
};

export const INTL_IMPORTANCE_QUESTION: IntlKeyValuePair = {
    key: "importanceQuestion",
    defaultValue:
        "Which of these is most important to you when applying to a University or College?",
    intlValue: "Which of these is most important to you when applying to a University or College?",
    namespace: IntlNamespaces.UNIVERSITY_CHAT,
};

export const INTL_IMPORTANCE_SUMBITTAL: IntlKeyValuePair = {
    key: "importanceSumbittal",
    defaultValue: (submittal: string) => `You submitted: ${submittal}`,
    intlValue: "You submitted: {{submittal}}",
    namespace: IntlNamespaces.UNIVERSITY_CHAT,
};

export const INTL_SUBMIT: IntlKeyValuePair = {
    key: "submit",
    defaultValue: "Submit",
    intlValue: "Submit",
    namespace: IntlNamespaces.UNIVERSITY_CHAT,
};

export const INTL_YOU_SUBMITTED: IntlKeyValuePair = {
    key: "youSubmitted",
    defaultValue: (answers: string) => `You submitted: ${answers}`,
    intlValue: "You submitted: {{answers}}",
    namespace: IntlNamespaces.UNIVERSITY_CHAT,
};
